import {
  CcfBox,
  CcfButton,
  CcfCopilotSuggestionIcon,
  CcfPictureUploadIcon,
  CcfTextField,
  CcfTypography,
  CcfUpArrowIcon,
} from '@nice-ccf/ui-controls';
import styles from './ccf-copilot-reimbursement-claim-form.module.scss';
import { MenuItem, Select } from '@mui/material';
import { useSelector } from 'react-redux';
import { getIsDamagedLuggagePhotoUploaded, getIsReimbursementClaimApproved } from '../../ccf-copilot-chat/+state/ccf-copilot.slice';


/* eslint-disable-next-line */
export interface CcfCopilotReimbursementClaimFormProps {}

/**
 * CcfCopilot - used to display Copilot Reimbursement claim Form for copilot Video call journey
 * @param props -?-CcfCopilotReimbursementClaimFormProps
 * @example <CcfCopilotReimbursementClaimForm />
 */
export function CcfCopilotReimbursementClaimForm(
  props: CcfCopilotReimbursementClaimFormProps
) {
  const isLuggagePhotoUploaded = useSelector(getIsDamagedLuggagePhotoUploaded);
  const isclaimApproved = useSelector(getIsReimbursementClaimApproved);

  return (
    <CcfBox className={styles.reimbursementformContainer}>
      {!isclaimApproved ? (
        <>
          <CcfBox className={styles.reimbursementformBlock}>
            <CcfBox className={styles.reimbursementForm}>
              <CcfBox mb={2}>
                <CcfTypography className={styles.title}>
                  Damaged Luggage Claim
                </CcfTypography>
              </CcfBox>

              <CcfBox className={styles.card} mb={2}>
                <CcfCopilotSuggestionIcon className={styles.cardIcon} />
                <CcfTypography className={styles.cardTxt}>
                  Auto-filled form
                </CcfTypography>
              </CcfBox>

              <CcfBox mb={2}>
                <CcfTypography className={styles.inputLabel}>
                  primary reason for claim{' '}
                  <span style={{ color: '#C2041A' }}>*</span>
                </CcfTypography>
                <Select
                  fullWidth
                  displayEmpty
                  name="claim Reason"
                  variant="outlined"
                  value={'Damage'}
                  className={styles.dropdown}
                  SelectDisplayProps={{
                    className: styles.inputTxt,
                  }}
                  sx={{
                    '&& fieldset': {
                      border: '1px solid #c4c4c4',
                    },
                  }}
                  IconComponent={() => (
                    <CcfUpArrowIcon className={styles.arrowIconForDropdown} />
                  )}
                >
                  <MenuItem value={'Damage'}>Damage</MenuItem>
                  <MenuItem value={'Foul Smell'}>Foul Smell</MenuItem>
                </Select>
              </CcfBox>

              <CcfBox mb={2}>
                <CcfTypography className={styles.inputLabel}>
                  Confirmation or bag tag number{' '}
                  <span style={{ color: '#C2041A' }}>*</span>
                </CcfTypography>
                <CcfTextField
                  fullWidth
                  id="bag tag number"
                  variant="outlined"
                  size="small"
                  value="5GV32A"
                  focused={false}
                  InputProps={{
                    className: styles.inputTxt,
                  }}
                />
              </CcfBox>

              <CcfBox mb={2}>
                <CcfTypography className={styles.inputLabel}>
                  where did you travel?
                </CcfTypography>
                <CcfTextField
                  fullWidth
                  id="bag tag number"
                  variant="outlined"
                  size="small"
                  value="Denver International Airport"
                  focused={false}
                  InputProps={{
                    className: styles.inputTxt,
                  }}
                />
              </CcfBox>

              <CcfBox>
                <CcfTypography className={styles.inputLabel}>
                  total amount claimed
                </CcfTypography>
                <CcfTextField
                  fullWidth
                  id="amount"
                  variant="outlined"
                  size="small"
                  value="$150.00"
                  focused={false}
                  InputProps={{
                    className: styles.inputTxt,
                  }}
                />
              </CcfBox>
            </CcfBox>

            <CcfBox className={styles.imgBlock}>
              {!isLuggagePhotoUploaded ? (
                <CcfBox className={styles.imgUploadContainer}>
                  <CcfPictureUploadIcon style={{ fontSize: '50px' }} />
                  <CcfTypography className={styles.screenshotUploadTxt}>
                    Take a screenshot of the damaged luggage
                  </CcfTypography>
                </CcfBox>
              ) : (
                <CcfBox>
                  <img
                    className={styles.damagedLuggageImg}
                    alt="Damaged Luggage"
                    src="./assets/damaged_luggage.png"
                  />
                </CcfBox>
              )}
            </CcfBox>
          </CcfBox>

          <CcfBox className={styles.btnContainer}>
            <CcfButton className={`${styles.btn} ${styles.CancelButton}`}>
              <CcfTypography
                className={`${styles.btnText} ${styles.txtCancel}`}
              >
                Cancel
              </CcfTypography>
            </CcfButton>
            <CcfButton className={`${styles.btn} ${styles.doneButton}`}>
              <CcfTypography className={`${styles.btnText} ${styles.txtDone}`}>
                Done
              </CcfTypography>
            </CcfButton>
          </CcfBox>
        </>
      ) : (
        <>
          <CcfBox className={styles.claimApprovedBlock}>
            <CcfBox mb={3}>
              <CcfTypography className={styles.title}>
                Claim Approved
              </CcfTypography>
            </CcfBox>

            <CcfBox mb={2}>
              <CcfTypography className={styles.confirmationTxt}>
                confirmation # 5gv32a
              </CcfTypography>
            </CcfBox>

            <CcfBox mb={2}>
              <CcfTypography className={styles.refundTxt}>
                Funds will be credited to client in 24-48 hours
              </CcfTypography>
            </CcfBox>

            <CcfBox mb={2}>
              <CcfTypography className={styles.label}>
                Claim Reason:
              </CcfTypography>
              <CcfTypography className={styles.inputTxt}>Damage</CcfTypography>
            </CcfBox>

            <CcfBox mb={2}>
              <CcfTypography className={styles.label}>
                Travel Location:
              </CcfTypography>
              <CcfTypography className={styles.inputTxt}>
                Denver International Airport
              </CcfTypography>
            </CcfBox>

            <CcfBox mb={2}>
              <CcfTypography className={styles.label}>
                Total Amount Requested:
              </CcfTypography>
              <CcfTypography className={styles.inputTxt}>$150.00</CcfTypography>
            </CcfBox>

            <CcfBox mb={2}>
              <CcfTypography className={styles.label}>
                Luggage Photo:
              </CcfTypography>
              <img
                className={styles.damagedLuggageImg}
                alt="Damaged Luggage"
                src="./assets/damaged_luggage.png"
              />
            </CcfBox>
          </CcfBox>
          <CcfBox className={styles.shareBtnBlock}>
            <CcfButton primary className={styles.shareBtn}>
              <CcfTypography className={styles.shareBtnText}>
                Share
              </CcfTypography>
            </CcfButton>
          </CcfBox>
        </>
      )}
    </CcfBox>
  );
}

export default CcfCopilotReimbursementClaimForm;
